export function backendErrorMessage(action, url, error) {
  console.error(`[Backend] ${action} fehlgeschlagen`, {
    url,
    message: error?.message,
    error
  });

  return "Backend nicht erreichbar. Details stehen in der Browser-Konsole.";
}

export function logWebSocketError(url, error) {
  console.error("[Backend] WebSocket-Verbindung fehlgeschlagen", {
    url,
    error
  });
}

export async function readJsonResponse(response, action, url) {
  const contentType = response.headers.get("content-type") || "";
  const text = await response.text();

  if (!contentType.includes("application/json")) {
    const preview = text.slice(0, 160);
    const error = new Error(
      `API returned ${contentType || "unknown content type"} with status ${response.status}: ${preview}`
    );

    console.error(`[Backend] ${action} lieferte keine JSON-Antwort`, {
      url,
      status: response.status,
      contentType,
      preview
    });

    throw error;
  }

  return text ? JSON.parse(text) : null;
}
